import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './breadcrumb.component';
import { BreadcrumbRoutingModule } from './breadcrumb-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {BreadcrumbModule} from "../../component/ing/breadcrumb/breadcrumb";
import {TableModule} from "../../component/ing/table/table";

@NgModule({
  imports: [
    CommonModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    BreadcrumbRoutingModule,
    BreadcrumbModule,
    TableModule
  ],
  declarations: [BreadcrumbComponent]
})
export class BreadcrumbDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/breadcrumb/breadcrumbDemo.module.ts